module.exports = __webpack_public_path__ + "img/gsu.d9c1d34f.jpg";